import { ChangeEvent, FC, useCallback } from 'react';
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  useTheme,
} from '@mui/material';
import ModalDialog from '../../common/components/ModalDialog';
import { ERelevance, IrrelevantApp } from '../irrelevant-apps-types';
import {
  setReleventAppType,
  setRelevetAppModal,
} from '../store-actions/irrelevant-apps-store-actions';
import { changeToReleventApp } from '../actions/irrelevant-apps-actions';
import ButtonGroup from '../../common/components/ButtonGroup';

const ReleventAppModal: FC<React.PropsWithChildren<RelevantAppModalProps>> = ({
  relevntModal,
  selectedApp,
  isRemoveIrrelevantAppLoading,
}) => {
  const theme = useTheme();

  const handleClose = useCallback(() => {
    setRelevetAppModal(false);
  }, []);

  const handleClick = useCallback(() => {
    changeToReleventApp();
  }, []);

  const handleCheckRelevnatType = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setReleventAppType(event.target.value as ERelevance);
    },
    [],
  );

  return (
    <ModalDialog
      onClose={handleClose}
      modalHeader='Make App Relevent'
      open={relevntModal}
      modalColor={theme.palette.info.main}
      aria-label='Exclude Issue'>
      <div>
        <Typography variant='body1' color='text.primary' mb={1} component='div'>
          <span>This will make the application</span>
          <span style={{ fontWeight: 'bold' }}>
            {` ${selectedApp && selectedApp.name} `}
          </span>
          <span>
            relevant again so that policies will be evaluated against the
            application. Please note that a new scan will be needed for issues
            related to the application to appear.
          </span>
        </Typography>
        <FormControl>
          <RadioGroup
            name='relevant-type-radio-buttons-group'
            onChange={handleCheckRelevnatType}>
            <FormControlLabel
              value={ERelevance.Relevant}
              control={<Radio />}
              label={
                <Typography variant='body1' color='text.primary'>
                  Make App Relevant: Always
                </Typography>
              }
            />
            <Typography variant='body2' color='text.primary' ml={4} mb={1}>
              This will keep the app relevant always. It will always be analyzed
              during a scan.
            </Typography>
            <FormControlLabel
              value={ERelevance.Default}
              control={<Radio />}
              label={
                <Typography variant='body1' color='text.primary'>
                  Make App Relevant: Ox Dynamic
                </Typography>
              }
            />
            <Typography variant='body2' color='text.primary' ml={4} mb={1}>
              The app relevancy will be determined by OX per scan. This resets
              the relevance to the default settings. Relevancy is affected by
              users, recent commits, archived status etc.
            </Typography>
          </RadioGroup>
        </FormControl>
        <Box display='flex' alignItems='end'>
          <ButtonGroup
            onCancel={handleClose}
            onClick={handleClick}
            buttonCancelLabel='Cancel'
            buttonCancelTooltip='Cancel'
            buttonActionLabel='Make App Relevant'
            buttonActionTooltip='Make App Relevant'
            isActionDisabled={false}
            isLoading={isRemoveIrrelevantAppLoading}
          />
        </Box>
      </div>
    </ModalDialog>
  );
};

export interface RelevantAppModalProps {
  relevntModal: boolean;
  selectedApp: IrrelevantApp | null;
  isRemoveIrrelevantAppLoading: boolean;
}

export default ReleventAppModal;
